import * as React from "react";

import { ColumnFilterDef } from "./ColumnFilterDef";
import { TextDropdownFilter } from "./TextDropdownFilter";

export const textColumnFilter = (
  getText: () => string | undefined,
  setText: (text: string) => void,
): ColumnFilterDef => ({
  getValue: () => {
    const t = getText();
    return t ? [t] : undefined;
  },
  render: (props) => (
    <TextDropdownFilter
      currentValue={getText()}
      cancel={() => {
        props.close();
      }}
      apply={(text) => {
        props.confirm();
        setText(text);
        props.setSelectedKeys(text ? [text] : []);
      }}
    />
  ),
});
